<template>
  <div id="event-day-add-update-dialog" class="custom-modal">
    <div class="modal-body">
      <transition name="el-fade-in" mode="out-in">
        <HolaconLottie v-if="loading == 'updateScreenLoading'" key="create-loading" />
        <el-row v-else key="content-loading">
          <el-col v-if="$store.state.eventprogram.days.length > 0" :span="24">
            <div class="day-list-head">
              <div>
                <i class="el-icon-loading" v-if="loading == 'loadingOrder'"> </i>
              </div>
              <div>{{ $t("contentManagement.eventProgram.components.title") }}</div>
              <div>{{ $t("contentManagement.eventProgram.components.date") }}</div>
              <div class="d-flex justify-content-center">{{ $t("contentManagement.eventProgram.components.viewing") }}</div>
              <div></div>
            </div>
            <draggable :list="$store.state.livesessions.days" handle=".el-icon-s-grid" class="day-list-container" @end="updateOrderNos">
              <div class="item" v-for="item in $store.state.eventprogram.days" :key="item.id" :class="{ passive: !item.isActive }">
                <div>
                  <i class="el-icon-loading burger" v-if="loading == item.id + '-listItem'"></i>
                  <i class="el-icon-s-grid burger" v-else></i>
                </div>
                <div>
                  <el-input v-model="item.title" @change="updateDay(item)" :class="$inputError('title', validationErrors)"></el-input>
                </div>
                <div>
                  <el-date-picker :format="datePickerDisplayFormat()" v-model="item.date" @change="updateDay(item)" :class="$inputError('date', validationErrors)" type="date" :placeholder="$t('contentManagement.eventProgram.components.placeholderPickDay')" :clearable="false"> </el-date-picker>
                </div>
                <div class="d-flex justify-content-center">
                  <el-switch v-model="item.isActive" @change="updateDay(item)"></el-switch>
                </div>
                <div class="btns d-flex justify-content-end">
                  <el-tooltip class="" effect="dark" :content="$t('event.table.delete')" placement="top">
                    <el-popconfirm @confirm="deleteDay(item.id)" :confirm-button-text="$t('contentManagement.eventProgram.components.delete')" :cancel-button-text="$t('contentManagement.eventProgram.components.cancel')" icon="el-icon-info" icon-color="red" :title="$t('contentManagement.eventProgram.components.deleteSureMsg')">
                      <el-button type="danger" slot="reference" :loading="loading == item.id + 'deleteItem'" circle icon="fas fa-trash" size="mini"></el-button>
                    </el-popconfirm>
                  </el-tooltip>
                </div>
              </div>
            </draggable>
          </el-col>
          <el-row v-else>
            <HolaconLottieNoData class="w-100" key="create-loading" :source="'holacon-programs-lottie'" :title="$t('contentManagement.eventProgram.days')" @btnAdd="createDay" @btnRefresh="false" :buttonAdd="true" :buttonRefresh="false" :loading="loading" />
          </el-row>
        </el-row>
      </transition>
    </div>
    <div class="modal-footer" slot="footer" v-if="loading != 'updateScreenLoading'">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("contentManagement.eventProgram.components.close") }}</el-button>
      </div>
      <div class="right-buttons">
        <el-button type="primary" :loading="loading == 'loadingCreate'" :disabled="loading == 'loadingCreate'" @click="createDay">{{ $t("contentManagement.eventProgram.components.addDay") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
export default {
  name: "EventDayAddUpdate",
  components: {
    draggable
  },
  data() {
    return {
      validationErrors: [],
      loading: false,
      updateTimeOut: null
    };
  },
  created() {
    this.loading = "updateScreenLoading";
    if (this.updateTimeOut != null) clearTimeout(this.updateTimeOut);
    this.updateTimeOut = setTimeout(() => {
      this.loading = false;
    }, 1000);
  },
  methods: {
    async updateOrderNos() {
      this.loading = "loadingOrder";
      if (this.updateTimeOut != null) clearTimeout(this.updateTimeOut);
      this.updateTimeOut = setTimeout(async () => {
        var payload = [];
        this.$store.state.eventprogram.days.map(x => {
          payload.push(x.id);
        });
        await this.$store.dispatch("orderDays", payload);
        this.loading = false;
      }, 500);
    },
    async createDay() {
      this.loading = "loadingCreate";
      if (this.updateTimeOut != null) clearTimeout(this.updateTimeOut);
      this.updateTimeOut = setTimeout(async () => {
        var payload = { title: null, date: null, isActive: false, id: null };
        if (this.$store.state.eventprogram.days.length > 0) {
          payload.title = this.$store.state.eventprogram.days.length + 1 + this.$t('dotDay');
        } else {
          payload.title = "1"+ this.$t('dotDay');
        }
        var res = await this.$store.dispatch("addUpdateDay", payload);
        this.validationErrors = res.data.validationErrors;
        this.loading = false;
      }, 500);
    },
    async updateDay(item) {
      this.loading = item.id + "-listItem";
      if (this.updateTimeOut != null) clearTimeout(this.updateTimeOut);
      this.updateTimeOut = setTimeout(async () => {
        var res = await this.$store.dispatch("addUpdateDay", item);
        this.validationErrors = res.data.validationErrors;
        this.loading = false;
      }, 500);
    },
    async deleteDay(id) {
      this.loading = id + "deleteItem";
      await this.$store.dispatch("deleteEventDay", id);
      this.loading = false;
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  }
};
</script>
<style lang="less" scoped>
.event-day-add-update {
  padding: 1rem;
}
.day-list-head {
  display: grid;
  grid-template-columns: 36px 1fr 1fr 90px 45px;
  align-items: center;
  padding: 10px;
  border-radius: 8px;
  background-color: #f1f1f1;
  font-weight: bold;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}
.day-list-container {
  .item {
    padding: 0.5rem;
    .el-date-editor {
      width: 100%;
    }
    margin-bottom: 8px;
    padding: 10px;
    gap: 0.5rem;
    transition: all 0.5s;
    border-radius: 8px;
    display: grid;
    grid-template-columns: 36px 1fr 1fr 90px 45px;
    align-items: center;
    background-color: #f1f1f1;
    &.passive {
      background-color: #fff2f2 !important;
    }
    i.burger {
      box-sizing: border-box;
      font-size: 20px;
      color: #505763;
      cursor: grab;
      &.me {
        color: #ccc;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/eventprogram/EventDayAddUpdate.vue